import styled from 'styled-components'

export default styled.div`
  font-size: calc(.8vw + .8vh + .2vmin)
`
